import axios from "axios";

const PROD_API_BASE = "https://www.frendrops.in/api";

export const getProducts = async (subcategoryId) => {
  try {
    const url = subcategoryId
      ? `${PROD_API_BASE}/home/products/by-subcategory/${encodeURIComponent(subcategoryId)}`
      : `${PROD_API_BASE}/products`;

    const response = await axios.get(url, {
      params: { page: 1, limit: 100 },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching products:", error);
    return { data: [] };
  }
};
